







import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateDuration } from "../../../domain/system";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "./mixins";
import OptionDropDownSelector from "./OptionDropDownSelector.vue";
import DateDurationPicker from "./DateDurationPicker.vue";

@Component({
  components: {
    OptionDropDownSelector,
    DateDurationPicker,
  }
})
export default class PresettableDateDurationPicker extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: () => [] as StandardOption<DateDuration>[] })
  presets: StandardOption<DateDuration>[];

  get isPresettable(): boolean {
    return !!this.presets
      && (0 < this.presets.length);
  }

  areEqual(source: DateDuration, destination: DateDuration): boolean {
    return DateDuration.areEqual(source, destination);
  }
}
